/// <reference types="node" />
class PushNotifications {
    vapidKey;
    registration = null;
    constructor(unregisteredCallback) {
        this.vapidKey = process.env.VAPID_KEY;
        if ('serviceWorker' in navigator && Boolean(this.vapidKey)) {
            window.addEventListener('load', () => {
                navigator.serviceWorker.register('/sw.js')
                    .then((reg) => {
                    this.registration = reg;
                    if (Notification.permission === "granted" && reg != null) {
                        this.GetSubscription(reg);
                    }
                    else {
                        if (Notification.permission !== "denied") {
                            if (unregisteredCallback && !this.IsSnoozed()) {
                                unregisteredCallback();
                            }
                        }
                    }
                });
            });
        }
    }
    IsSnoozed() {
        return document.cookie.indexOf("notificationDlgSnooze=1") >= 0;
    }
    SetSnoozeCookie() {
        const d = new Date();
        d.setMonth(d.getMonth() + 1);
        document.cookie = `notificationDlgSnooze=1;expires=${d.toUTCString()}`;
    }
    RequestPermission(callback) {
        Notification.requestPermission((status) => {
            if (status === "granted" && this.registration != null) {
                this.GetSubscription(this.registration).then(() => {
                    if (callback)
                        callback();
                });
            }
        });
    }
    async GetSubscription(reg) {
        return reg.pushManager.getSubscription().then((sub1) => {
            if (sub1 === null) {
                reg.pushManager.subscribe({
                    userVisibleOnly: true,
                    applicationServerKey: this.vapidKey
                }).then((sub2) => {
                    this.SaveSubscription(sub2);
                }).catch((e) => {
                    console.error("Unable to subscribe to push messages", e);
                });
            }
        });
    }
    async SaveSubscription(sub) {
        if (sub !== null) {
            const response = await fetch(`/api/pushMessaging`, {
                method: 'POST',
                body: JSON.stringify({
                    endpoint: sub.endpoint,
                    p256dh: this.ArrayBufferToBase64(sub.getKey("p256dh")),
                    auth: this.ArrayBufferToBase64(sub.getKey("auth"))
                }),
                headers: {
                    "content-type": 'application/json',
                    Accept: 'application/json'
                },
                credentials: 'include'
            });
            if (!response.ok) {
                console.error('Unable to save push messaging subscription', response.status, response.statusText);
            }
        }
    }
    ArrayBufferToBase64 = (buffer) => {
        let binary = '';
        const bytes = new Uint8Array(buffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    };
}
export default PushNotifications;
//# sourceMappingURL=pushNotifications.js.map